<template>
  <v-list-item class="item-bottom-border" :class="{ 'v-list-item--active': this.user.id === activeUser }" @click="$emit('onSelected')">
    <v-list-item-content>
      <v-list-item-title> {{ user.lastname }} {{ user.firstname }} </v-list-item-title>

      <v-list-item-subtitle v-if="closedEvaluations" class="success--text">
        {{ closedEvaluations }} {{ $t('bf.closedEvaluations') }}
      </v-list-item-subtitle>

      <v-list-item-subtitle v-if="openEvaluations" class="error--text"> {{ openEvaluations }} {{ $t('bf.openEvaluations') }} </v-list-item-subtitle>
    </v-list-item-content>
    <v-list-item-action class="pt-3">
      <v-badge v-if="closedEvaluations" class="pb-1" inline color="success" :content="closedEvaluations"></v-badge>
      <v-badge v-if="openEvaluations" inline color="error" :content="openEvaluations"></v-badge>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
export default {
  name: 'UserListItem',
  props: {
    user: Object,
    openEvaluations: Number,
    closedEvaluations: Number,
  },
  computed: {
    activeUser() {
      return Number(this.$route.params.userId);
    },
  },
};
</script>
